export default "__VITE_ASSET__D5lVb9pR__"